import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarSparkleOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9 6c2.25 3.375 5.625 6.75 9 9-3.375 2.25-6.75 5.625-9 9-2.25-3.375-5.625-6.75-9-9 3.375-2.25 6.75-5.625 9-9m0 3.05A37.2 37.2 0 0 1 3.05 15 37.2 37.2 0 0 1 9 20.948 37.2 37.2 0 0 1 14.948 15 37.2 37.2 0 0 1 9 9.05"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19 0c1.25 1.875 3.125 3.75 5 5-1.875 1.25-3.75 3.125-5 5-1.25-1.875-3.125-3.75-5-5 1.875-1.25 3.75-3.125 5-5m0 2.944A22 22 0 0 1 16.944 5 22 22 0 0 1 19 7.055 22 22 0 0 1 21.055 5 22 22 0 0 1 19 2.944"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HyperstarSparkleOutlinedSize24Glyph.displayName = 'HyperstarSparkleOutlinedSize24Glyph';
